﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKFormElement from '@tk/controls/tk.form.element';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKTable from '@tk/components/tk.table';
import TKFlag from '@tk/components/tk.flag';
import TKTooltip from '@tk/components/tk.tooltip';
import DIWViewport from '@/basics/diw.viewport';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKContextMenu from '@tk/components/tk.context.menu';
import DIWDialog from '@/components/diw.dialog';
import TKCompareOverview from '@tk/components/compare/tk.compare.overview';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKCompareCategorySwitch from '@tk/components/compare/tk.compare.category.switch';
import TKPrice from '@tk/components/tk.price';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKStaticContent from '@tk/controls/tk.static.content';
import DIWStock from '@/components/diw.stock';
import { configureStore } from '@tk/utilities/tk.use.store';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/compare.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class Compare extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: DIWViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-dialog', constructor: DIWDialog },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-compare-overview', constructor: TKCompareOverview },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-compare-category-switch', constructor: TKCompareCategorySwitch },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'diw-stock', constructor: DIWStock },
        ]);
    }
}

new Compare();
